import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRejected = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 17,
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M0 8.5c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8-8-3.589-8-8Zm1.284 0A6.723 6.723 0 0 0 8 15.216 6.723 6.723 0 0 0 14.716 8.5 6.723 6.723 0 0 0 8 1.784 6.723 6.723 0 0 0 1.284 8.5Zm9.676-2.017L8.93 8.51l2.03 2.029a.666.666 0 1 1-.943.943L7.988 9.454 5.96 11.483a.665.665 0 0 1-.942 0 .666.666 0 0 1 0-.943l2.028-2.029-2.028-2.028a.666.666 0 1 1 .942-.943l2.03 2.029 2.028-2.029a.666.666 0 1 1 .943.943Z",
		clipRule: "evenodd"
	})
});
export default SvgRejected;
